function Step2DefaultContactContent({
 templateState,
 setTemplateField,
}) {
 return (
  <div className="card">
   <h2>Contact page content</h2>

   <label className="field">
    <span>Page title</span>
    <input
     value={templateState.title || ""}
     onChange={(e) => setTemplateField("title", e.target.value)}
     placeholder="League Contact"
    />
   </label>

   <div className="row-2">
    <label className="field">
     <span>Contact name</span>
     <input
      value={templateState.contact_name || ""}
      onChange={(e) =>
       setTemplateField("contact_name", e.target.value)
      }
      placeholder="League Commissioner"
     />
    </label>
   </div>

   <div className="row-2">
    <label className="field">
     <span>Email</span>
     <input
      value={templateState.contact_email || ""}
      onChange={(e) =>
       setTemplateField("contact_email", e.target.value)
      }
      placeholder="hello@example.com"
     />
    </label>

    <label className="field">
     <span>Phone label</span>
     <input
      value={templateState.contact_phone_label || ""}
      onChange={(e) =>
       setTemplateField("contact_phone_label", e.target.value)
      }
      placeholder="Text Message Number"
     />
    </label>
   </div>

   <label className="field">
    <span>Phone number</span>
    <input
     value={templateState.contact_phone || ""}
     onChange={(e) =>
      setTemplateField("contact_phone", e.target.value)
     }
     placeholder="(714) 555-1234"
    />
   </label>

   <label className="field">
    <span>Intro text</span>
    <textarea
     value={templateState.intro_text || ""}
     onChange={(e) =>
      setTemplateField("intro_text", e.target.value)
     }
     className="textarea"
     rows={5}
     placeholder="Reach out with any questions about registration, schedules, or league details."
    />
   </label>
  </div>
 );
}

export default Step2DefaultContactContent;